<template>
  <div>
    <div class="compart" v-if="compartData && isCustomer">
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            合同编号：<span class="blue" @click="goPackForCode(compartData.id,compartData.cusId)">{{compartData.contractCode}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            客户名称：<span class="blue" @click="goCustomerDetail(compartData.cusId)">{{compartData.cusName}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            客户合同编号：<span>{{compartData.customerContractCode || '--'}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            合同金额：<span>{{compartData.contractTotal | toFixed}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            已收账款：<span>{{compartData.accountsReceived | toFixed}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            应收账款：<span>{{compartData.accountsCollect | toFixed}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            已到期应收账款：<span>{{compartData.accountsDue | toFixed}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            未到期应收账款：<span>{{compartData.accountsOutstanding | toFixed}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            合同状态：<span class="green">{{compartState[compartData.signState]}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            签订时间：<span>{{compartData.signDate | formatData}}</span>
          </div>
        </el-col>
        <el-col :span="8" v-if="isDeilvery">
          <div class="pb20">
            发货方式：<span>{{compartData.deliverySetting === 1 ? '现货现发,期货到货后发货' : '整单到期发货'}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="">
            当前负责人：<span>{{compartData.ownName}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="">
            更新时间：<span>{{compartData.updateDate | formatData}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="compart" v-if="compartData && !isCustomer">
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            合同编号：<span class='blue' @click="goForCode(dataList[compartData.contractState - 1],compartData.pcbId)">{{compartData.pcbNumber}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            供应商：<span class="blue" v-cust @click="goSupplierDetail(compartData.spId)">{{compartData.suName}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            供应商合同编号：<span>{{compartData.supplierContractNumber || '--'}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            合同金额：<span>{{compartData.purchaseTotal | toFixed}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            已付账款：<span>{{compartData.actualTotal | toFixed}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            应付账款：<span>{{compartData.accountsPayable | toFixed}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            已到期应付账款：<span>{{compartData.accountsDue | toFixed}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            未到期应收账款：<span>{{compartData.accountsOutstanding | toFixed}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="pb20">
            合同状态：<span class="green">{{dataList[compartData.contractState - 1]}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            签订时间：<span>{{compartData.signTime | formatData}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="pb20">
            发货方式：<span>{{compartData.sendType}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="">
            当前负责人：<span>{{compartData.staffUsename || compartData.ownName}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="">
            更新时间：<span>{{compartData.updateDate | formatData}}</span>
          </div>
        </el-col>
         <el-col :span="8" v-if='compartData.stockupType === "直发备货"'>
          <div class="">
            备注：<span>{{compartData.ocbMark || '--'}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { compartState } from '@/meun/date'

export default {
  name: 'compartModule',
  props: {
    compartData: {
      type: Object,
      default: () => {
      }
    },
    isCustomer: {
      type: Boolean,
      default: true
    },
    isDeilvery: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      compartState,
      dataList: [
        '待审核',
        '审核中',
        '履行中',
        '已履行',
        '审核通过待签署',
        '已作废',
        '审核不通过',
        '审核驳回',
        '盖章审批'
      ]
    }
  },
  methods: {
    goPackForCode (id, cusId) {
      if (this.compartData.signState === 4 || this.compartData.signState === 5) {
        this.$router.push({ name: 'contractEdit', query: { id, cusId } })
        return
      }
      this.$router.push({ name: 'contractCreate', query: { id, cusId } })
    },
    // 采购合同编号跳转合同页面
    goForCode(type, pcbId) {
      if (type === '履行中' || type === '已履行') {
        this.$router.push({
          name: 'contractDetails',
          query: { type: type, pcbId: pcbId }
        })
      } else {
        this.$router.push({
          name: 'createContract',
          query: { type: type, pcbId: pcbId }
        })
      }
    },
    goCustomerDetail (id) {
      this.$router.push({ name: 'customer/details', query: { id } })
    },
    goSupplierDetail (id) {
      this.$router.push({ name: 'supplierEdit', query: { id } })
    }
  }
}
</script>

<style scoped>
  .blue {
    color: #276CFF;
    cursor: pointer;
  }
  .green{
    color:#60C96D;
  }
</style>
